<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">{{ $timeAgo(date) }}</span>
    </template>
    <span>
      {{ $formatDate(date, "d MMMM y, H:mm") }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    dateStr: {
      type: String,
      required: true,
    },
  },
  computed: {
    date() {
      return this.$parseDate(this.dateStr)
    },
  },
}
</script>
